export enum OpportunitiesEvents {
  MOVE_HOMEPAGE_TAB = "move_homepage_tab",
  CLICK_ON_OPPORTUNITY = "click_on_opportunity",
  COPY_OPPORTUNITY_TRANSACTION = "copy_opportunity_transaction",
  VERIFY_OPPORTUNITY_TRANSACTION = "verify_opportunity_transaction",
  HIDE_OPPORTUNITY_TRANSACTION = "hide_opportunity_transaction",
  CLICK_ON_OPPORTUNITY_ARTICLE_LINK = "click_on_opportunity_article_link",
}
